module.exports = __webpack_public_path__ + "img/quote4.290ed599.jpg";